import { Component, Vue } from 'vue-property-decorator';

@Component({
    metaInfo() {
        return {
            title: 'Privacy statement',
        };
    },
})
export default class Privacy extends Vue {
    documents: any[] = [];

    active = 0;

    get document() {
        if (this.documents[this.active]) {
            return this.documents[this.active];
        } else {
            return null;
        }
    }

    created() {
        this.getData();
    }

    async getData() {
        const query: any[] = [
            this.$prismic.Predicates.at('document.type', 'privacy_statement'),
        ];

        const documents = await this.$prismic.client.query(
            query,
            {
                orderings: `[my.privacy_statement.language]`,
            },
        );

        for (const document in documents.results) {
            if (documents.results[document]) {
                this.documents.push(documents.results[document]);


                if (documents.results[document].data.language[0].text === 'English') {
                    this.active = parseInt(document, 10);
                }
            }
        }
    }
}
